import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VLayout,{ref:"container",attrs:{"column":"","justify-center":"","align-center":"","pa-4":""}},_vm._l((_vm.optionList),function(option){return _c('div',{key:option.text},[_c('span',{on:{"click":function($event){return _vm.onSelect(option)}}},[_vm._v(_vm._s(option.text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }